// Copyright ©️ 2026 eVolve MEP, LLC

import { type RenderableUser, useEvolvePaginatedGet } from '@evolvemep/api-ts';
import { Stack } from '@mantine/core';

import { SearchableCheckList } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableCheckList';
import { UserInfoBadge } from 'components/Mantine/UserInfoBadge';

type Props = {
  value?: RenderableUser[] | null;
  onChange: (value: RenderableUser[] | null) => void;
  disabled?: boolean;
};

export const MultiUserSelect = ({ value, onChange, disabled }: Props) => {
  const paginatedGetUsers = useEvolvePaginatedGet('admin/user');
  return (
    <Stack gap={0} w={350} maw="75vw" style={{ overflow: 'hidden' }}>
      <SearchableCheckList
        value={value ?? undefined}
        onChange={onChange}
        idKey="userId"
        paginatedGet={paginatedGetUsers}
        getItemLabel={(user) => <UserInfoBadge user={user} />}
        disabled={disabled}
      />
    </Stack>
  );
};
